module.exports = require("@splunk/dashboard-visualizations/Column");